import {
  URL_ABOUT_PROJECT,
  URL_BANNER,
  URL_CHAT,
  URL_COURSES,
  URL_FAQ,
  URL_MAIN,
  URL_NEWS,
  URL_NOTIFICATIONS,
  URL_PROFILE_OVERVIEW,
  URL_QUESTIONS,
  URL_SOS,
  URL_SOS_PLACE,
  URL_TEAM,
  URL_USERS,
  URL_VICTIM,
  URL_VOTE_CATEGORY,
} from "./page_urls";

export const adminSidebarItems = [
  {
    header: "Sahifalar",
    items: [
      {
        title: "Asosiy",
        href: URL_MAIN,
        icon: "home-1",
        fontIcon: "bi-layers",
      },
      {
        title: "SOS murojaatlar",
        href: URL_SOS,
        icon: "satellite",
        fontIcon: "bi-layers",
      },
      {
        title: "Viktimlik arizalar",
        href: URL_VICTIM,
        icon: "like-folder",
        fontIcon: "bi-layers",
      },
      {
        title: "Chat",
        href: URL_CHAT,
        icon: "messages",
        fontIcon: "bi-layers",
      },
      {
        title: "Kurslar",
        href: URL_COURSES,
        icon: "book",
        fontIcon: "bi-layers",
      },
      {
        title: "Yangiliklar",
        href: URL_NEWS,
        icon: "notepad-bookmark",
        fontIcon: "bi-layers",
      },
      {
        title: "Foydalanuvchilar",
        href: URL_USERS,
        icon: "people",
        fontIcon: "bi-layers",
      },
      {
        title: "SOS markazlari",
        href: URL_SOS_PLACE,
        icon: "geolocation",
        fontIcon: "bi-layers",
      },
      {
        title: "Murojaat savollari",
        href: URL_VOTE_CATEGORY,
        icon: "message-question",
        fontIcon: "bi-layers",
      },
    ],
  },
  {
    header: "Yordamchi",
    items: [
      {
        title: "Savol-Javoblar",
        href: URL_QUESTIONS,
        icon: "message-question",
        fontIcon: "bi-layers",
      },
      {
        title: "Xabarlar",
        href: URL_NOTIFICATIONS,
        icon: "notification",
        fontIcon: "bi-layers",
      },
      {
        title: "Tezkor savollar",
        href: URL_FAQ,
        icon: "question-2",
        fontIcon: "bi-layers",
      },
      {
        title: "Bannerlar",
        href: URL_BANNER,
        icon: "slider-horizontal",
        fontIcon: "bi-layers",
      },
      {
        title: "Jamoa",
        href: URL_TEAM,
        icon: "profile-user",
        fontIcon: "bi-layers",
      },
      {
        title: "Loyiha haqida",
        href: URL_ABOUT_PROJECT,
        icon: "information-2",
        fontIcon: "bi-layers",
      },
    ],
  },
  {
    header: "Akkount",
    items: [
      {
        title: "Kabinet",
        href: URL_PROFILE_OVERVIEW,
        icon: "user-square",
        fontIcon: "bi-layers",
      },
    ],
  },
];
